const EyeClosedIcon = ({ size = 24, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M17.7851 8.70534C19.6553 10.0818 20.7455 11.6672 20.8311 11.7866C20.9231 11.8934 20.9231 12.107 20.8311 12.2138C20.6778 12.4275 17.3048 17.3402 12.0001 17.3402C11.1261 17.3402 10.3045 17.2068 9.54115 16.9831M15.3144 7.31336C14.3204 6.91596 13.2105 6.66016 12.0001 6.66016C6.69541 6.66016 3.32236 11.5728 3.16909 11.7866C3.0771 11.929 3.0771 12.1069 3.16909 12.2138C3.26526 12.3477 4.62815 14.3305 6.93993 15.7901"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M18.5 5L4.5 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path
            d="M9.87162 14.1137C8.70004 12.9422 8.70004 11.0427 9.87162 9.87109C11.0432 8.69952 12.9427 8.69952 14.1143 9.87109L9.87162 14.1137Z"
            fill="currentColor"
        />
        <path
            d="M14.6207 11.4809C14.7546 11.347 14.9804 11.4061 15.0087 11.5933C15.1463 12.5032 14.8653 13.4639 14.1646 14.1646C13.4639 14.8653 12.5032 15.1463 11.5933 15.0087C11.4061 14.9804 11.3469 14.7546 11.4809 14.6207L14.6207 11.4809Z"
            fill="currentColor"
        />
    </svg>
)

export default EyeClosedIcon
